module.exports = __webpack_public_path__ + "img/horizontal_6_6_pp13_9006.5cecd282.png";